<template>
<!-- eslint-disable max-len -->
<span>
  <top-bar v-if="narrative.showNavbar">
    <template :slot="narrative.showMetrics ? 'challenge' : 'default'">{{ narrativeNavbarText }}</template>
    <cash-navbar v-if="narrative.showMetrics" slot="cash"></cash-navbar>
    <metrics-navbar v-if="narrative.showMetrics" slot="metrics"></metrics-navbar>
  </top-bar>

  <transition enter-active-class="animated slideInDown" leave-active-class="animated fadeOut">
    <div class="report">
      <span class="report-header"><h2>Your demonstrated leadership style</h2></span>
      <div class="report-flex">
        <div class="report-blurb">
          <h2 class="report-header">LEADERSHIP STYLE</h2>
          <p v-if="activetab === 1">The choices you made reflect an Transformational leadership style. Transformational leadership is characterized by the embodiment of high standards that are associated with one’s beliefs and core values. Such leaders wish to instill these same standards in others. Transformational leaders serve as role models and inspire performance beyond expectations. Such leaders challenge the way others think about problems. Additionally, they help others develop their full leadership potential.</p>
          <p v-if="activetab === 2">The choices you made reflect an Transactional leadership style. Constructive transactional leadership is characterized by a focus on clear expectations, goals, and standards. Such leaders provide feedback on progress and prioritize meeting obligations and commitments. Corrective transactional leadership is characterized by a focus on setting clear standards to monitor performance and intervention to correct deviations from those standards. Such leaders establish precise protocols in order to sustain performance levels by identifying and correcting mistakes.</p>
          <p v-if="activetab === 3">The choices you made reflect a DIRECTIVE leadership style. Directive leadership is characterized by exerting control over situations and giving orders to others on what is expected in terms of performance. Directive leadership makes it clear who is in charge.</p>
          <p v-if="activetab === 4">The choices you made reflect an Participative leadership style. Participative leadership is characterized by working side-by-side with others and sharing in the decision-making process to come up with the best solutions.</p>
          <p v-if="activetab === 5">The choices you made reflect an Passive leadership style. Passive leadership is characterized by avoidance of conflict and a desire to avoid making decisions. While not taking action may be described as “empowering others,” it usually means an abdication of the responsibility to lead. Passive leaders generally let problems work themselves out.</p>
          <p v-if="activetab === 6">The choices you made reflect an Authentic leadership style. Authentic leadership is characterized by high moral and ethical standards and conduct. Such leaders exhibit a greater sense of self-awareness in terms of how others are impacted by their leadership. Furthermore, they exhibit transparent relationships with others by openly exchanging ideas and information. They are balanced leaders, meaning they tend to suspend judgment on people and decisions until all relevant data is available.</p>
        </div>
        <div class="report-blurb">
          <radar :stats="stats" :polycolor="polycolor" :radar="radar"></radar>
        </div>
      </div>
      <div id="tabs" class="container">
        <div class="tabs">
            <span class="tabLabel">Learn More</span>
            <a v-on:click="activetab=1" v-bind:class="[ activetab === 1 ? 'active' : '' ]">Transformational</a>
            <a v-on:click="activetab=2" v-bind:class="[ activetab === 2 ? 'active' : '' ]">Transactional</a>
            <a v-on:click="activetab=3" v-bind:class="[ activetab === 3 ? 'active' : '' ]">Directive</a>
            <a v-on:click="activetab=4" v-bind:class="[ activetab === 4 ? 'active' : '' ]">Participative</a>
            <a v-on:click="activetab=5" v-bind:class="[ activetab === 5 ? 'active' : '' ]">Passive</a>
            <a v-on:click="activetab=6" v-bind:class="[ activetab === 6 ? 'active' : '' ]">Authentic</a>
        </div>
        <div class="content">
            <div v-if="activetab === 1" class="tabcontent">
                <h3>Name: Leadership: Theory and Practice, 7th Edition</h3>
                <h3>Subtitle: Peter G. Northouse</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>Translated into 12 different languages and used in 89 countries, this market-leading text successfully combines an academically robust account of the major theories and models of leadership with an accessible style and practical examples that help students apply what they learn. Peter G. Northouse uses a consistent format for each chapter, allowing students to compare the various theories. Each chapter includes three case studies that provide students with practical examples of the theories discussed. Adopted at more than 1,000 colleges, universities, and institutions worldwide, Leadership: Theory and Practice provides readers with a user-friendly account of a wide range of leadership research in a clear, concise, and interesting manner.</p>
                <p>link: <a href="http://www.amazon.com/Leadership-Practice-Peter-G-Northouse/dp/1483317536" target="_blank">Amazon</a></p>

                <hr>

                <h3>Name: Transformational Leadership 2nd Edition</h3>
                <h3>Subtitle: Bernard M. Bass,Ronald E. Riggio</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>Transformational Leadership, Second Edition is intended for both the scholars and serious students of leadership. It is a comprehensive review of theorizing and empirical research that can serve as a reference and starting point for additional research on the theory.</p>
                <p>It can be used as a supplementary textbook in an intense course on leadership - or as a primary text in a course or seminar focusing on transformational leadership.</p>
                <p>New in the Second Edition:</p>
                <p>New, updated examples of leadership have been included to help illustrate the concepts, as well as show the broad range of transformational leadership in a variety of settings.</p>
                <p>New chapters have been added focusing specifically on the measurement of transformational leadership and transformational leadership and effectiveness.</p>
                <p>The discussion of both predicators and effects of transformational leadership is greatly expanded.</p>
                <p>Much more emphasis is given to authentic vs. inauthentic transformational leadership.</p>
                <p>Suggestions are made for guiding the future of research and applications of transformational leadership.</p>
                <p>A greatly expanded reference list is included.</p>
                <p>link: <a href="http://www.amazon.com/Transformational-Leadership-Bernard-M-Bass/dp/0805847626" target="_blank">Amazon</a></p>

                <hr>

                <h3>Name: Transformational Leadership: The Key to Employee Engagement and Commitment</h3>
                <h3>Subtitle: Joanne L. Smikle</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>Employee engagement— commitment, they are two sides of the same coin. Building and sustaining the level of commitment required to have a cadre of employees who are fully engaged and excited about the mission and the work of the enterprise requires thoughtful work on the part of human resource professionals. This article identifies practical strategies for using the principles of transformational leadership to create commitment and, ultimately high levels of engagement.</p>
                <p>link: <a href="http://www.smiklespeaks.com/files/articles/HRKY_Fall14.pdf" target="_blank">smiklespeaks.com</a></p>

                <hr>

                <h3>Name: What is TRANSFORMATIONAL LEADERSHIP?</h3>
                <h3>Subtitle: created by Better Business Learning</h3>
                <h3>Type: READING</h3>
                <p>link: <a href="https://www.youtube.com/watch?v=60O2OH7mHys" target="_blank">YouTube</a></p>
            </div>
            <div v-if="activetab === 2" class="tabcontent">
                <h3>Name: Leadership (Harper Perennial Political Classics) 1st Edition</h3>
                <h3>Subtitle: James M. Burns</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>Pulitzer Prize-winning historian James MacGregor Burns devoted his legendary career to the study of leadership in all its aspects—from politics to business. Leadership, Burns's pioneering study, introduces the highly influential theory of "transformational leadership," stating that the best leaders are those who inspire others to come together toward the achievement of higher aims. Featuring fascinating case studies drawn from history, Leadership is the classic text for anyone seeking to understand executive decision-making, the dynamics of influence, and moral leadership.</p>
                <p>link: <a href="http://www.amazon.com/Leadership-Harper-Perennial-Political-Classics/dp/006196557X" target="_blank">Amazon</a></p>

                <hr>

                <h3>Name: A Look at the Benefits of Transactional Leadership Style</h3>
                <h3>Subtitle: Eryn Travis , Demand Media</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>In leadership articles and studies, the transactional style is usually juxtaposed with the transformational style, with the latter presented as more of the ideal. While the transactional approach is more closely aligned with management than leadership, small business owners should consider the transactional style under certain conditions. After all, the most effective leaders understand a variety of approaches and know how to apply each style to meet specific situations.</p>
                <p>link: <a href="http://smallbusiness.chron.com/look-benefits-transactional-leadership-style-15346.html" target="_blank">chron.com</a></p>

                <hr>

                <h3>Name: Transactional leadership</h3>
                <h3>Subtitle: Created at http://goanimate.com/</h3>
                <h3>Type: OTHER</h3>
                <p>link: <a href="https://www.youtube.com/watch?v=jVde5oPm8aM" target="_blank">YouTube</a></p>
            </div>
            <div v-if="activetab === 3" class="tabcontent">
                <h3>Name: Leadership development in balance: Made/Born</h3>
                <h3>Subtitle: Avolio, B.J. (2005). NJ: Erlbaum & Associates</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>This book, written by a leading scholar in leadership, takes readers through a very realistic look at what it takes to develop leadership competencies. Focusing on four major goals, this text:</p>
                <p>*provides the reader with a broader and deeper understanding of what constitutes authentic leadership development;</p>
                <p>*challenges a very basic notion that leaders are born versus made;</p>
                <p>*talks about the elements that comprise leadership development so readers are informed to ask the many providers of leadership development the right questions; and</p>
                <p>*develops full leadership potential.</p>
                <p>There are numerous case examples used throughout the book: high-tech executives, community leaders, correctional service supervisors, bank managers in Canada, and platoon commanders in Israel. Each example is used as a general basis for discussing how people develop their leadership potential, and as models of training and evaluation.</p>
                <p>Leadership Development in Balance: MADE/Born is intended for graduate or undergraduate students of leadership, project managers, supervisors, senior executives, school principles, health care officers, or legislators.</p>
                <p>link: <a href="http://www.amazon.com/Leadership-Development-Balance-MADE-Born/dp/080583284X/ref=asap_bc?ie=UTF8" target="_blank"></a>Amazon</p>

                <hr>

                <h3>Name: Directive Leadership: 10 Telling Signs and How to Kick the Habit</h3>
                <h3>Subtitle: TRAVIS BENNETT</h3>
                <h3>Type: READING</h3>
                <p>link: <a href="https://blog.udemy.com/directive-leadership/" target="_blank">Udemy.com</a></p>

                <hr>

                <h3>Name: Directive Leadership Style: Definition & Concept</h3>
                <h3>Subtitle: Shawn Grimsley</h3>
                <h3>Type: OTHER</h3>
                <h3>Description:</h3>
                <p>The directive leadership style is one of four leadership behaviors characterized by setting clear objectives and rules for your subordinates and ensuring that your expectations and directions are clearly defined and understood. Identified by the path-goal theory of leadership, directive leadership may be advisable when subordinates are unskilled or inexperienced at a complex task. It may backfire, however, if imposed upon highly skilled and experienced employees who are extremely competent to perform the task.</p>
                <p>link: <a href="http://study.com/academy/lesson/directive-leadership-style-definition-lesson-quiz.html" target="_blank">Study.com</a></p>
            </div>
            <div v-if="activetab === 4" class="tabcontent">
                <h3>Name: The Pfeiffer Book of Successful Team-Building Tools: Best of the Annuals 2nd Edition</h3>
                <h3>Subtitle: Elaine Biech</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>Year after year, consultants, trainers, and human resource professionals have come to rely on The Pfeiffer Annuals to provide them with the most current and quality tools on a wide variety of topics. In this book, editor Elaine Biech and contributors to the Annuals have honed in on the important theme of team building to create the first topic-specific book in The Pfeiffer Annuals series. The Pfeiffer Book of Successful Team-Building Tools, 2nd Edition, includes an innovative ten-block model for building a high-performance team and draws on the best-on-the-topic articles from thirty-five years of Annuals volumes.</p>
                <p>link: <a href="http://www.amazon.com/Pfeiffer-Book-Successful-Team-Building-Tools/dp/0787997366" target="_blank">Amazon</a></p>

                <hr>

                <h3>Name: What Managers Think of Participative Leadership</h3>
                <h3>Subtitle: Larry E. Greiner</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>An extroverted, sensitive leader who openly shares decisions and authority with subordinates—this is the profile that emerged when 318 executives were asked their opinions on the characteristics of participative leadership. While there is much discussion—and controversy—among educators and theorists about the concept of participative leadership, managers themselves have not yet been heard. In this study, the author found a surprising consensus among managers regarding the operational characteristics and effectiveness of participative leadership. But he also found some specific and noteworthy differences of opinion between younger and older managers concerning which managerial actions get results. After discussing the findings, he draws their implications for companies, individual managers, and management educators.</p>
                <p>link: <a href="https://hbr.org/1973/03/what-managers-think-of-participative-leadership" target="_blank">hbr.org</a></p>

                <hr>

                <h3>Name: Participative Leadership</h3>
                <h3>Subtitle: Created at http://goanimate.com/</h3>
                <h3>Type: OTHER</h3>
                <p>link: <a href="https://www.youtube.com/watch?v=MszLwLycpBo" target="_blank">YouTube</a></p>
            </div>
            <div v-if="activetab === 5" class="tabcontent">
                <h3>Name: Horses Never Lie: The Heart of Passive Leadership</h3>
                <h3>Subtitle: Mark Rashid</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>In Horses Never Lie, renowned horse trainer Mark Rashid challenges the conventional wisdom of “alpha leadership” and teaches the reader to become a “passive leader”—a counterpart to the kind of horse other members of a herd choose to associate with and to follow. Applying Rashid’s principles and techniques helps cultivate horse personalities that are responsive and dependable regardless of the rider. Reliving Rashid’s experiences with him, you will come to feel the same sort of compassion and appreciation for your horses that you do for the people in your life. This new edition features added introductory notes for each chapter that contribute to a more complete understanding of Rashid’s methods and philosophy.</p>
                <p>link: <a href="http://www.amazon.com/Horses-Never-Lie-Passive-Leadership/dp/1616082410" target="_blank">Amazon</a></p>

                <hr>

                <h3>Name: The effects of passive leadership on workplace incivility</h3>
                <h3>Subtitle: Crystal M. Harold and Brian C. Holtz</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>In this article, we examine the effects of passive leadership on workplace incivility across two studies. Study 1 examines passive leadership–incivility relationships in a sample of employee–supervisor dyads, and Study 2 examines these relationships in a sample of employee–coworker dyads. Results from these studies suggest that passive leadership has a significant direct effect on behavioral incivility and an indirect effect through experienced incivility. Moreover, our results suggest that the relationship between experienced incivility and behavioral incivility is conditional on the level of passive leadership, such that the effect of experienced incivility on behavioral incivility is stronger at higher levels of passive leadership.</p>
                <p>link: <a href="http://onlinelibrary.wiley.com/doi/10.1002/job.1926/full" target="_blank">wiley.com</a></p>
            </div>
            <div v-if="activetab === 6" class="tabcontent">
                <h3>Name: True North: Discover Your Authentic Leadership</h3>
                <h3>Subtitle: Bill George,Peter Sims,David Gergen (Foreword)</h3>
                <h3>Type: READING</h3>
                <h3>Description:</h3>
                <p>True North shows how anyone who follows their internal compass can become an authentic leader. This leadership tour de force is based on research and first-person interviews with 125 of today’s top leaders—with some surprising results. In this important book, acclaimed former Medtronic CEO Bill George and coauthor Peter Sims share the wisdom of these outstanding leaders and describe how you can develop as an authentic leader. True North presents a concrete and comprehensive program for leadership success and shows how to create your own Personal Leadership Development Plan centered on five key areas:</p>
                <p>Knowing your authentic self</p>
                <p>Defining your values and leadership principles</p>
                <p>Understanding your motivations</p>
                <p>Building your support team</p>
                <p>Staying grounded by integrating all aspects of your life</p>
                <p>True North offers an opportunity for anyone to transform their leadership path and become the authentic leader they were born to be.</p>
                <p>Personal, original, and illuminating stories from Warren Bennis, Sir Adrian Cadbury, George Shultz (former U.S. secretary of state), Charles Schwab, John Whitehead (Cochairman, Goldman Sachs), Anne Mulcahy (CEO, Xerox), Howard Schultz (CEO, Starbucks), Dan Vasella (CEO, Novartis), John Brennan (Chairman, Vanguard), Carol Tome (CFO, Home Depot), Donna Dubinsky (CEO/cofounder, Palm), Alan Horn (President, Warner Brothers), Ann Moore (CEO, Time, Inc.) and many others illustrate the transitions that shape the type of leaders who will thrive in the 21st century.</p>
                <p>Bill George (Cambridge, MA) has spent over 30 years in executive leadership positions at Litton, Honeywell, and Medtronic. As CEO of Medtronic, he built the company into the world’s leading medical technology company as its market capitalization increased from $1.1 billion to $60 billion. Since 2004, he has been a professor at the Harvard Business School. His 2004 book Authentic Leadership (0-7879-7528-1) was a BusinessWeek bestseller. Peter Sims (San Francisco, CA) established “Leadership Perspectives,” a course on leadership development at the Stanford Graduate School of Business and cofounded the London office of Summit Partners, a leading investment firm.</p>
                <p>link: <a href="http://www.amazon.com/True-North-Discover-Authentic-Leadership/dp/0787987514/ref=pd_sim_14_1?ie=UTF8&dpID=51%2BN6nYLVfL&dpSrc=sims&preST=_AC_UL160_SR106%2C160_&refRID=061KZ2CCHPH46T2T8QRAhttp://www.amazon.com/True-North-Discover-Authentic-Leadership/dp/0787987514/ref=pd_sim_14_1?ie=UTF8&dpID=51%2BN6nYLVfL&dpSrc=sims&preST=_AC_UL160_SR106%2C160_&refRID=061KZ2CCHPH46T2T8QRA" target="_blank">Amazon</a></p>

                <hr>

                <h3>Name: Four Steps To Becoming An Authentic Leader</h3>
                <h3>Subtitle: Bruce Jones, Disney Institute</h3>
                <h3>Type: READING</h3>
                <p>link: <a href="http://www.forbes.com/sites/disneyinstitute/2016/03/01/four-steps-to-becoming-an-authentic-leader/#6c90853c269d" target="_blank">Forbes</a></p>

                <hr>

                <h3>Name: TEDx: Get Access To Authentic Leadership - How To Be a Leader Series</h3>
                <h3>Subtitle: Thomas D. Zweifel</h3>
                <h3>Type: OTHER</h3>
                <p>link: <a href="https://www.youtube.com/watch?v=tpiVqpBcWx4" target="_blank">YouTube</a></p>
            </div>
        </div>
      </div>
    </div>
  </transition>

  <transition enter-active-class="animated slideInRight" leave-active-class="animated slideOutRight">
    <narrator v-if="false" :character="characters[narrative.rightCharacter]" :left="narrative.type === 'leftVideo'"></narrator>
  </transition>
 <!--
  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <narrator-notification v-if="showNarratorNotification" class="narrator-notification" :style="{ left: narrative.type === 'leftVideo' ? '10px' : 'unset', right: rightVideo ? '10px' : 'unset' }" :left="narrative.type === 'leftVideo'">
      {{ narrativeText }}
    </narrator-notification>
  </transition> -->

  <transition enter-active-class="animated fadeIn" leave-active-class="animated fadeOut">
    <bottom-bar :next="showNarratorNotification ? onComplete : undefined" :tabindex="3" ref="bottomBar" :noBar="true">
      <span slot="button">
        <span v-html="(narrative && narrative.nextButtonText) ? narrative.nextButtonText : ((game && game.nextButtonDefaultText) ? game.nextButtonDefaultText : 'Next')"></span>
      </span>
    </bottom-bar>
  </transition>
</span>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters } from 'vuex';

import TopBar from '../ui/TopBar';
import MetricsNavbar from '../ui/MetricsNavbar';
import CashNavbar from '../ui/CashNavbar';
import Narrator from '../ui/Narrator';
import NarratorNotification from '../ui/NarratorNotification';
import BottomBar from '../ui/BottomBar';
import Radar from '../ui/Radar';

export default {
  // $emit 'input' on complete
  components: {
    TopBar,
    MetricsNavbar,
    CashNavbar,
    Narrator,
    NarratorNotification,
    BottomBar,
    Radar
  },
  data() {
    return {
      activetab: 1,
      showNarrator: false,
      showNarratorNotification: false,
      radar: {
        size: '370',
        viewbox: '1200',
        radius: '340'
      },
      stats: [
        {
          name: 'Transformational',
          value: 0,
        },
        {
          name: 'Transactional',
          value: 0,
        },
        {
          name: 'Directive',
          value: 0,
        },
        {
          name: 'Participative',
          value: 0,
        },
        {
          name: 'Passive',
          value: 0,
        },
        {
          name: 'Authentic',
          value: 0,
        }
      ]
    };
  },
  computed: {
    ...mapGetters([
      'activeEnvironment',
      'characters',
      'narrative',
      'tooltip',
      'game',
      'lastNarrative',
      'nextNarrative',
      'narrativeNavbarText',
      'narrativeText',
      'group'
    ]),
    polycolor() {
      if (this.activeEnvironment && this.activeEnvironment.secondaryBorderColor) {
        return this.activeEnvironment.secondaryBorderColor;
      }
      return 'rgba(255, 255, 255, 0.5)';
    },
  },
  async created() {
    await this.loadPageData();
    this.setStats();
  },
  methods: {
    ...mapActions([
      'getMyGroup'
    ]),
    async show() {
      this.showNarrator = true;
      await new Promise(resolve => setTimeout(resolve, 1250));
      this.showNarratorNotification = true;
      await new Promise(resolve => setTimeout(resolve, 1250));
      await Vue.nextTick();
    },
    async reset() {
      await Vue.nextTick();
      await this.show();
    },
    navigate() {
      this.$refs.bottomBar.navigate();
    },
    async onComplete() {
      if (this.tooltip && this.tooltip.preventStateProgressionWhileOpen) {
        window.dispatchEvent(new Event('click'));
        return;
      }
      this.$emit('input');
    },
    async loadPageData() {
      try {
        const { _id: groupId } = this.group;
        await this.getMyGroup({ groupId });
      } catch (err) {
        if (await this.$router.handleGameError(err)) return;
        this.$router.showGameErrorCritical();
      }
    },
    setStats() {
      const mLength = this.group.players[0].metrics.length;
      let maxStat = 0;
      let activeStat = 1;

      for (let i = 0; i < mLength; i++) {
        this.stats[i].value = this.group.players[0].metrics[i].value * 10;
        if (this.stats[i].value > maxStat) {
          maxStat = this.stats[i].value;
          activeStat = i + 1;
        }
      }

      this.activetab = activeStat;
    }
  },
  watch: {
    async narrative(newValue) {
      if (newValue) await this.reset();
    }
  },
  async mounted() {
    await this.show();
  }
};
</script>

<style lang="scss" scoped>
h3 {
  font-size: 1.3rem;
}
hr {
  border-top: 1px solid #e9ecef;
}
.report {
  position: absolute;
  width: 1150px;
  height: 850px;
  top: 30px;
  left: 30px;
  background-color: var(--primaryColor);
  border-radius: 5px;
  color: white;
  z-index: 1;
}
.report-flex {
  display: flex;
  background-color: white;
  color: black;
  box-shadow: inset 0px 0px 20px 0px rgba(219,212,219,1);
}
.report-header {
  width: 100%;
  text-align: center;
}
.report-blurb {
  width: 550px;
  height: 300px;
  padding: 10px;
  margin: 10px 0px 10px 16px;
  font-weight: 600;
  align-content: center;
}

.slideInDown {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.19, 1, 0.22, 1); // out expo
}
.fadeOutUp {
  animation-duration: 1s;
  animation-timing-function: cubic-bezier(0.55, 0.055, 0.675, 0.19); // in cubic
}
.narrator-notification {
  bottom: 205px;
}

/* Style the tabs */
.tabs {
  overflow: hidden;
  margin-right: 40px;
  margin-left: 10px;
  margin-bottom: -2px; // hide bottom border
}

.tabs ul {
  list-style-type: none;
  margin-left: 20px;
}

.tabs a{
  float: right;
  cursor: pointer;
  color: var(--primaryColor);
  padding: 12px 24px;
  transition: background-color 0.2s;
  border: 1px solid #ccc;
  border-right: none;
  background-color: #f1f1f1;
  border-radius: 10px 10px 0 0;
  font-weight: bold;
}
.tabs a:last-child {
  border-right: 1px solid #ccc;
}

/* Change background color of tabs on hover */
.tabs a:hover {
  background-color: #aaa;
  color: #fff;
}

/* Styling for active tab */
.tabs a.active {
  background-color: #fff;
  color: #484848;
  border-bottom: 2px solid #fff;
  cursor: default;
}

/* Style the tab content */
.tabcontent {
  padding: 30px;
  max-height: 400px;
  overflow-y: scroll;
}
.container {
  margin-top: 10px;
}
.tabLabel {
  font-size: 34px;
}
.v-radar {
  margin-left: 100px;
  margin-top: -40px;
  position: absolute;
  right: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/game/narrative/NarrativeLeadershipReportLegacy.vue